import { render, staticRenderFns } from "./SwitchLanguage.vue?vue&type=template&id=22d47837&scoped=true&"
import script from "./SwitchLanguage.vue?vue&type=script&lang=js&"
export * from "./SwitchLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SwitchLanguage.vue?vue&type=style&index=0&id=22d47837&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d47837",
  null
  
)

export default component.exports